module.exports = __webpack_public_path__ + "img/procedure_02_b.f48b197f.jpg";